import { FC, PropsWithChildren } from 'react';

const DisableOnSSR: FC<PropsWithChildren<{}>> = ({ children }) => (
  typeof window !== 'undefined'
    ? (<>{children}</>)
    : (<></>)
);

export default DisableOnSSR;
